import {
  FaShieldAlt,
  FaTachometerAlt,
  FaMoneyBillWave,
  FaBalanceScale,
} from "react-icons/fa";
import "./three.css";

const ChooseUs = () => {
  const list = [
    {
      img: <FaShieldAlt className="text-black text-4xl" />,
      title: "Enhance Security",
      style: "rb",
      text: "Our cutting-edge security technological solutions provide an additional layer of protection against security threats.",
    },
    {
      img: <FaTachometerAlt className="text-black text-4xl" />,
      title: "Increase Efficiency",
      style: "lb",
      text: "Our automated security systems streamline security operations, reducing the need for manual intervention.",
    },
    {
      img: <FaMoneyBillWave className="text-black text-4xl" />,
      title: "Reduce Costs",
      style: "tr",
      text: "Our security technological solutions can help clients reduce security-related costs, such as personnel and equipment expenses.",
    },
    {
      img: <FaBalanceScale className="text-black text-4xl" />,
      title: "Improve Compliance",
      style: "tl",
      text: "Our security technological solutions help clients meet regulatory requirements and industry standards.",
    },
  ];

  return (
    <div className="three bg-black" id="about">
      <div className="three-block">
        <p className="subtitle ash pry-text">WHY CHOOSE US</p>
        <p className="header ash pry-text center">
          Benefits of Working with{" "}
          <span className="white">Noble Secure Technologies</span>
        </p>
      </div>
      <div className="three-table">
        {list.map((item) => (
          <div className={`three-card bg-ash ${item.style}`} key={item.title}>
            <div className="shadow-lg mx-auto px-2 py-1 rounded-lg bg-[rgba(255,255,255,0.9)] flex items-center justify-center">
              {item.img}
            </div>
            <p className="title pry-text center white">{item.title}</p>
            <p className="pry-text white center list shift-up">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseUs;
